// extracted by mini-css-extract-plugin
module.exports = {"departments":"il","departmentHeading":"jl","departmentSection":"kl","departmentName":"ll","departmentLink":"ml","expandIcon":"nl"};